import { Controller } from "@hotwired/stimulus";

// Bingebase Binge Scale Lexicon
const BINGE_SCALE = {
  1: "Hard Pass",
  2: "A Chore",
  3: "Flawed",
  4: "Meh",
  5: "Fine",
  6: "Decent",
  7: "Good Binge",
  8: "Great Binge",
  9: "Total Binge",
  10: "Absolute Binge!",
};

export default class extends Controller {
  static targets = ["star", "label"];
  static values = { current: Number };

  connect() {
    this.updateStars();
    // Store the original label text for restoration
    if (this.hasLabelTarget) {
      this.originalLabelText = this.labelTarget.textContent.trim();
      // If the original text is empty (rated media), we need to construct the default text
      if (!this.originalLabelText) {
        // Try to determine media type from the DOM or use a generic fallback
        this.originalLabelText = "Rate this item";
      }
    }
    // Only update label if there's an existing rating
    if (this.currentValue > 0) {
      this.updateLabel();
    }
  }

  currentValueChanged() {
    this.updateStars();
    // Only update label if there's a rating or if we're in an interactive state
    if (this.currentValue > 0) {
      this.updateLabel();
    }
  }

  highlight(event) {
    const targetValue = parseInt(
      event.target.closest("[data-star-rating-value]").dataset.starRatingValue
    );
    this.highlightStars(targetValue, true);
    this.updateLabel(targetValue, true);
  }

  unhighlight() {
    this.updateStars();
    this.updateLabel();
  }

  rate(event) {
    const targetValue = parseInt(
      event.target.closest("[data-star-rating-value]").dataset.starRatingValue
    );
    this.currentValue = targetValue;
  }

  highlightStars(value, isHover = false) {
    this.starTargets.forEach((star) => {
      const starValue = parseInt(star.dataset.starRatingValue);
      const button =
        star.querySelector("button") ||
        star.querySelector('input[type="submit"]') ||
        star.querySelector("a") ||
        star;

      if (!button) return;

      // Clear all classes first
      button.classList.remove(
        "text-slate-600",
        "text-slate-500",
        "text-orange-500",
        "text-orange-400",
        "opacity-50",
        "opacity-75"
      );

      if (isHover) {
        // During hover: show preview for all stars up to hovered value
        if (starValue <= value) {
          button.classList.add("text-orange-500");
        } else {
          // Beyond hovered value - show empty state
          button.classList.add("text-slate-600");
        }
      } else {
        // Not hovering: restore based on current rating
        if (starValue <= this.currentValue) {
          // Permanently rated stars
          button.classList.add("text-orange-500");
        } else if (this.currentValue > 0) {
          // Has rating but this star isn't filled
          button.classList.add("text-slate-500");
        } else {
          // No rating - empty state
          button.classList.add("text-slate-600");
        }
      }
    });
  }

  updateStars() {
    this.highlightStars(this.currentValue, false);
  }

  updateLabel(value = null, isHover = false) {
    if (!this.hasLabelTarget) return;

    const displayValue = value !== null ? value : this.currentValue;
    const label = this.labelTarget;

    if (isHover && displayValue > 0) {
      // Show binge scale label during hover
      const scaleText = BINGE_SCALE[displayValue];
      const isBingeWorthy = displayValue >= 7;

      label.textContent = scaleText;
      label.style.color = isBingeWorthy ? "#f7750b" : "#ffffff";
    } else if (!isHover && this.currentValue > 0) {
      // Show saved rating label
      const scaleText = BINGE_SCALE[this.currentValue];
      const isBingeWorthy = this.currentValue >= 7;

      label.textContent = scaleText;
      label.style.color = isBingeWorthy ? "#f7750b" : "#ffffff";
    } else if (!isHover) {
      // Show default call-to-action text only when not hovering
      label.style.color = "#f7750b";
      label.textContent = this.originalLabelText;
    }
  }
}
